export default "__VITE_ASSET__9a64b63e__"